export default __webpack_public_path__ + "static/media/component-db.765b0f5a.svg";